import { ReactNode, useState } from "react";

interface AccordionProps {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
  badge?: string;
}

export default function Accordion({ title, defaultOpen = false, children, badge }: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="accordion">
      <button className="accordion-header" onClick={() => setOpen((prev) => !prev)} aria-expanded={open}>
        <div className="accordion-title">{title}</div>
        <div className="accordion-actions">
          {badge && <span className="tag">{badge}</span>}
          <span className="accordion-icon">{open ? "−" : "+"}</span>
        </div>
      </button>
      {open && <div className="accordion-body">{children}</div>}
    </div>
  );
}
